var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemainingOkasBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.313,
    height: 31,
    viewBox: "0 0 30.313 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9938",
    "data-name": "Group 9938",
    transform: "translate(18672 2474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9938-2",
    "data-name": "Group 9938",
    transform: "translate(-18671 -2473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9935",
    "data-name": "Group 9935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7327",
    "data-name": "Path 7327",
    className: "cls-1",
    d: "M18.62,27.6A14.161,14.161,0,1,0,0,14.156c0,.43.019.856.069,1.4A14.2,14.2,0,0,0,9.814,27.611",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7074",
    "data-name": "Path 7074",
    className: "cls-2",
    d: "M0,19.731A11.678,11.678,0,0,0,11.678,8.053,11.618,11.618,0,0,0,8.458,0C8.406-.047,0,8.053,0,8.053Z",
    transform: "translate(14.156 22.181) rotate(180)"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1827",
    "data-name": "Ellipse 1827",
    className: "cls-2",
    cx: 2.357,
    cy: 2.357,
    r: 2.357,
    transform: "translate(-18659 -2447.714)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainingOkasBoxes);
export default __webpack_public_path__ + "static/media/RemainingOkasBoxes.4e0aafecfb3fb4bd4c9c508add8e872d.svg";
export { ForwardRef as ReactComponent };